import { api } from '@/api/http'

export interface CartPartInfo {
  id: number
  title: string
  slug: string
  partNumber: string
  price: number | string
  stockCount: number
  inStock: boolean
  isOEM: boolean
  images: any
  category: string
  brand: string
}

export interface CartItemData {
  id: number
  userId: number
  partId: number
  quantity: number
  createdAt: string
  part: CartPartInfo
}

export interface CartResponse {
  items: CartItemData[]
  totalCount: number
  totalAmount: number
}

export interface ShippingAddressPayload {
  fullName: string
  phone: string
  addressLine1: string
  addressLine2?: string
  city: string
  state: string
  postalCode: string
}

export const cartService = {
  getCart: () =>
    api.get<CartResponse>('/cart'),

  addToCart: (partId: number, quantity = 1) =>
    api.post<CartItemData>('/cart', { partId, quantity }),

  updateQuantity: (id: number, quantity: number) =>
    api.patch<{ success: boolean }>(`/cart/${id}`, { quantity }),

  removeItem: (id: number) =>
    api.delete<{ success: boolean }>(`/cart/${id}`),

  clearCart: () =>
    api.delete<{ success: boolean }>('/cart'),

  checkout: (shippingAddress: ShippingAddressPayload, paymentMethod = 'ONLINE') =>
    api.post<any>('/orders/checkout', { shippingAddress, paymentMethod }),

  getMyOrders: () =>
    api.get<any[]>('/orders/my-orders'),

  getAllOrders: () =>
    api.get<any[]>('/orders/admin/all'),

  updateOrderStatus: (id: number, status: string, trackingNumber?: string) =>
    api.patch<any>(`/orders/admin/${id}/status`, { status, trackingNumber }),
}
